import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Separator } from '@/components/ui/separator';
import { Type, Loader2, Upload } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

import { API } from '@/lib/apiBase';

export const HeroSectionCard = ({
  settings, updateField,
  heroRef, uploadingHero, onHeroUpload,
  imgVersion,
}) => {
  const { t } = useLanguage();

  return (
    <Card className="bg-card border-border">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-6">
          <Type className="w-5 h-5 text-primary" />
          <h2 className="text-lg font-bold">{t('siteSettings.heroSection')}</h2>
        </div>

        <div className="space-y-4">
          <div>
            <Label className="text-sm">{t('siteSettings.heroImage')}</Label>
            <div className="flex items-center gap-4 mt-1">
              {settings.has_custom_hero && (
                <img
                  src={`${API}/site-settings/hero-image?${imgVersion}`}
                  alt="Hero"
                  className="w-24 h-16 object-cover rounded-sm bg-muted"
                />
              )}
              <div>
                <input ref={heroRef} type="file" accept="image/*" onChange={onHeroUpload} className="hidden" />
                <Button
                  variant="outline" size="sm"
                  onClick={() => heroRef.current?.click()}
                  disabled={uploadingHero}
                  data-testid="upload-hero-btn"
                >
                  {uploadingHero ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <Upload className="w-4 h-4 mr-2" />}
                  {t('siteSettings.uploadHero')}
                </Button>
                <p className="text-xs text-muted-foreground mt-1">{t('siteSettings.heroHint')}</p>
              </div>
            </div>
          </div>

          <Separator />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            {[1, 2, 3].map((n) => (
              <div key={n}>
                <Label className="text-sm">{t(`siteSettings.heroTitle${n}`)}</Label>
                <Input
                  value={settings[`hero_title_${n}`] || ''}
                  onChange={(e) => updateField(`hero_title_${n}`, e.target.value)}
                  className="bg-secondary border-border mt-1"
                  data-testid={`hero-title-${n}`}
                />
              </div>
            ))}
          </div>
          <div>
            <Label className="text-sm">{t('siteSettings.heroDescription')}</Label>
            <Input
              value={settings.hero_description || ''}
              onChange={(e) => updateField('hero_description', e.target.value)}
              className="bg-secondary border-border mt-1"
              data-testid="hero-description"
            />
          </div>
        </div>
      </CardContent>
    </Card>
  );
};
